export default __webpack_public_path__ + "static/media/paid-blue-24-dp-1.07c739a1.svg";